export default __webpack_public_path__ + "static/media/notification-sound.3e0e8067.mp3";